import { Box } from "@mui/material";
import ThermoWaterLoading from "../components/ThermoWaterLoading";

export default function LoadingPage({ duration = 2.5 }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <ThermoWaterLoading duration={duration} />
    </Box>
  );
}
